import { render, staticRenderFns } from "./CreateNewEmailTemplatesModal.vue?vue&type=template&id=4b9309e6"
import script from "./CreateNewEmailTemplatesModal.vue?vue&type=script&lang=js"
export * from "./CreateNewEmailTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports